import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
          Paper,
    TableCell,  Card, Box, Typography, IconButton, FormHelperText, Tooltip, TextField, InputAdornment,
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import { getDashboardPageStyles } from "../../utils/dashboardPageStyles";
import SchoolIcon from '@material-ui/icons/School';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, Chip } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SuperActivityService from "./Locality/Service/superActivityService";
import { canEditDeleteActivityRow } from "../../utils/activityRowPermissions";
import {
  buildListSchoolRequest,
  buildScopedListBody,
  effectiveSchoolIdForWrite,
  filterRowsBySchoolScope,
  getUserDetails,
  resolveRowSchoolId,
  resolveSchoolId,
  resolveSchoolIdForClass,
  resolveRowSchoolLabel,
  isSchoolAddedRow,
  shouldShowSchoolColumn,
  dedupeSuperActivitiesForFilter,
  filterRowsBySuperActivity,
  filterRowsByClassId,
} from "../../utils/activityCatalogScope";

const useStyles = makeStyles((theme) => ({
    ...getDashboardPageStyles(theme),
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dialogPaper: {
        borderRadius: 14,
        width: 317,
        maxWidth: '95vw',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2.5),
    },
    fieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
    },
    dialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    emptyFilterBox: {
        marginTop: 12,
        padding: '10px 14px',
        borderRadius: 10,
        backgroundColor: '#fff8e6',
        border: '1px solid #ffe4a3',
    },
    emptyFilterText: {
        color: '#7a5c00',
        fontSize: '0.875rem',
        lineHeight: 1.55,
    },
    placeholderText: {
        color: '#94a3b8',
        fontStyle: 'italic',
        fontSize: '0.875rem',
    },
}));
export default function Activity({ embedded = false, scope = null, sharedClassList = null }) {
    const tableHeaders = ['Class', 'Area Of Work', 'List Of Activities', 'Add More', 'Actions'];
    const classes = useStyles();
    const userDetails = useMemo(
        () => scope?.userDetails || getUserDetails(),
        [scope]
    );
    const useExternalScope = embedded && scope != null;
    const scopeSchoolId = scope?.filterSchoolId ?? '';
    const scopeClassId = scope?.filterClassId ?? '';
    const [filterExercise, setExercise] = useState('');
    const [filterActivityList, setFilterActivityList] = useState([]);
    const [filterActivity, setActivity] = useState('');
    const [filterExerciseList, setExerciseList] = useState([]);
    const [temActivitylList, setTempActivityList] = useState([]);
    const [tabelList, setTabelList] = useState([]);
    const [filterSuperActivity, setfilterSuperActivity] = useState('');
    const [filterClassId, setFilterClassId] = useState('');
    const [classNameList, setClassNameList] = useState([]);
    const [activitylList, setActivityList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [superActivityList, setSuperActivityList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [tabelIdList, setTabelIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [tabel, setTabel] = useState({
        classId: '',
        superActivityId: '',
        activityName: '',
        notes: '',
        schooleId: '',
    });
    const [viewOpen, setViewOpen] = useState(false);
    const [viewRow, setViewRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        superActivityId: Yup.string().required('super Activity Name is required'),
        activityName: Yup.string().required('Activity Name is required'),

    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const loadSuperActivitiesForClass = useCallback((classId) => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) {
            setAddSuperActivityList([]);
            return;
        }
        const applyAreas = (res) => {
            const rows = filterRowsBySchoolScope(
                Array.isArray(res) ? res : [],
                useExternalScope ? scopeSchoolId : ''
            );
            setAddSuperActivityList(
                classId ? rows : dedupeSuperActivitiesForFilter(rows)
            );
        };
        if (classId) {
            SuperActivityService.getAllSuperActivityById(listId, { classId }, role)
                .then(applyAreas)
                .catch(() => setAddSuperActivityList([]));
            return;
        }
        SuperActivityService.getAllSuperActivity(listId, role)
            .then(applyAreas)
            .catch(() => setAddSuperActivityList([]));
    }, [userDetails, useExternalScope, scopeSchoolId]);

    const effectiveClassFilter = useExternalScope ? scopeClassId : filterClassId;

    useEffect(() => {
        if (!useExternalScope) return;
        setfilterSuperActivity('');
        setpg(0);
    }, [scopeSchoolId, scopeClassId, useExternalScope]);

    const applySchoolScopedRows = useCallback((rows) => {
        return filterRowsBySchoolScope(
            Array.isArray(rows) ? rows : [],
            useExternalScope ? scopeSchoolId : ''
        );
    }, [useExternalScope, scopeSchoolId]);

    const fetchFilteredActivities = useCallback(() => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;

        const hasClass = Boolean(effectiveClassFilter);
        const hasArea = Boolean(filterSuperActivity);

        const finalizeRows = (res) => {
            let rows = applySchoolScopedRows(res);
            if (hasClass) rows = filterRowsByClassId(rows, effectiveClassFilter);
            if (hasArea) rows = filterRowsBySuperActivity(rows, filterSuperActivity);
            setTabelList(rows);
            setTempActivityList(rows);
        };

        if (!hasClass && !hasArea) {
            ActivityTabelService.getAllActivityTabel(listId, role)
                .then(finalizeRows)
                .catch(() => {});
            return;
        }

        if (!hasClass && hasArea) {
            ActivityTabelService.getAllActivityTabel(listId, role)
                .then(finalizeRows)
                .catch(() => {});
            return;
        }

        const reqBody = buildScopedListBody(listId, {
            ...(hasClass ? { classId: effectiveClassFilter } : {}),
            ...(hasArea ? { superActivityId: filterSuperActivity } : {}),
        });

        ActivityTabelService.getAllActivityTabeBySuperActivityId(reqBody)
            .then(finalizeRows)
            .catch(() => {
                ActivityTabelService.getAllActivityTabel(listId, role)
                    .then(finalizeRows)
                    .catch(() => {});
            });
    }, [
        effectiveClassFilter,
        filterSuperActivity,
        userDetails,
        useExternalScope,
        scopeSchoolId,
        applySchoolScopedRows,
    ]);

    useEffect(() => {
        loadSuperActivitiesForClass(effectiveClassFilter || null);
    }, [effectiveClassFilter, scopeSchoolId, loadSuperActivitiesForClass]);

    useEffect(() => {
        setpg(0);
        fetchFilteredActivities();
    }, [fetchFilteredActivities]);

    useEffect(() => {
        if (sharedClassList) {
            setAddClassList(sharedClassList);
            return;
        }
        getAddClassList();
        return () => {
            setTabelIdList([]);
            setSuperActivityList([]);
            setTabelList([]);
            setAddSuperActivityList([]);
            setAddClassList([]);
        }
    }, [sharedClassList, scopeSchoolId, useExternalScope]);
    const filterSuperActivitys = (event)=>{

        setfilterSuperActivity(event.target.value);
        if(event.target.value){
        
            // const filterValue = temActivitylList.filter(act=>act.superActivityId._id === event.target.value);
            // setActivityList(filterValue);
            const setValues = temActivitylList.map(result=>{
                return {name:result.ActivityName,value:result._id};
            });
            setExerciseList(setValues);
           
        }else{
            setActivityList(temActivitylList);
            const setValues = temActivitylList.map(result=>{
                return {name:result.activityName,value:result._id};
            });
            setExerciseList(setValues);
        }
    
        }
        const filterExcDetails = (event) => {
        const extId = event?event._id:'';
            setExercise(extId);
            if (extId) {
                const filterValue = temActivitylList.filter(act => act._id === extId);
                setTabelList(filterValue);
            } else {
                setTabelList(temActivitylList);
            }
    
        }
 
        const getSuperActivityList = (event) => {
            loadSuperActivitiesForClass(event.target.value);
        }
    const getActivityTabelList = () => {
        fetchFilteredActivities();
    }
    const handleOpen = (status) => {
        if(status){
            const nextClassId = useExternalScope ? (scopeClassId || '') : '';
            setTabel({
            classId: nextClassId,
            superActivityId: '',
            activityName: '',
            notes: '',
            schooleId: resolveSchoolIdForClass(
                addClassList,
                nextClassId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ),
        })
        }
     
          setOpen(true);
      };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };

    const getAddClassList = () => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;

        AddClassService.getAllAddClass(listId, role).then((res) => {
            setAddClassList(res);
            if (!useExternalScope && res.length > 0) {
                setFilterClassId(res[0]._id);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getClassNameList = (event) => {
        AddClassService.getAddClassNameById({ className: event.target.value }).then((res) => {

            setClassNameList(res);

        }).catch((err) => {
            setError(err.message);
        });
    }
    const editActivityTabel = (tabel) => {
        const obj = JSON.parse(JSON.stringify(tabel));

        obj.superActivityId = tabel.superActivityId ? tabel.superActivityId._id : '';
        obj.classId = tabel.classId ? tabel.classId._id :'';
        obj.notes = tabel.notes || '';
        obj.schooleId = resolveRowSchoolId(tabel) || resolveSchoolIdForClass(
            addClassList,
            obj.classId,
            useExternalScope ? scopeSchoolId : '',
            userDetails
        );
        getSuperActivityList({target:{value:obj.classId}}) 
        //  tabel.superActivityId = tabel.superActivityId ? tabel.superActivityId._id :''; 
        setTabel(obj)
        handleOpen(false)
    }
    const addActivityFromRow = (row) => {
        const nextClassId = row.classId ? (row.classId._id || row.classId) : '';
        const nextSuperActivityId = row.superActivityId
            ? (row.superActivityId._id || row.superActivityId)
            : '';
        if (nextClassId) {
            getSuperActivityList({ target: { value: nextClassId } });
        }
        setTabel({
            classId: nextClassId,
            superActivityId: nextSuperActivityId,
            activityName: '',
            notes: '',
            schooleId: resolveRowSchoolId(row) || resolveSchoolIdForClass(
                addClassList,
                nextClassId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ),
        });
        setOpen(true);
    };
    const openView = (row) => {
        setViewRow(row || null);
        setViewOpen(true);
    };
    const closeView = () => {
        setViewOpen(false);
        setViewRow(null);
    };
    const deleteActivityTabel = (tabeldelete) => {
        if (!tabeldelete) return;
        setPendingDelete(tabeldelete);
        setDeleteConfirmOpen(true);
    };
    const confirmDelete = async () => {
        const row = pendingDelete;
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
        if (!row) return;
        try {
            await ActivityTabelService.deleteActivityTabel(row);
            getActivityTabelList();
        } catch {
            // ignore
        }
    };
    const formik = useFormik({
        initialValues: tabel,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            values.schooleId = values.schooleId || resolveSchoolIdForClass(
                addClassList,
                values.classId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ) || effectiveSchoolIdForWrite(userDetails, useExternalScope ? scopeSchoolId : '');
            if (!values.schooleId) {
                alert('Please select a school in the scope filters before adding an activity.');
                return;
            }
            if (tabel._id) {
                ActivityTabelService.upadeActivityTabel(values).then((res) => {
                    handleClose();
                    getActivityTabelList();
                    // getSuperActivityList()
                    resetForm()
                    alert("Activity Tabel Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                ActivityTabelService.creteActivityTabel(values).then((res) => {
                    getActivityTabelList();
                    resetForm();
                    handleClose();
                    alert(" Activity Tabel Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {

                        alert(err.response.data.message)
                    })
            }

        },
    });

    const emptyActivityMessage = useMemo(() => {
        const selectedClass = addClassList.find((c) => String(c._id) === String(effectiveClassFilter));
        const classLabel = selectedClass?.className || 'this class';
        const selectedArea = addSuperActivityList.find(
            (area) => String(area._id) === String(filterSuperActivity)
        );

        if (filterSuperActivity && selectedArea) {
            return `No list activities yet for "${selectedArea.superActivityName}" in ${classLabel}. Areas of work are added on the Area Of Work tab. Use Add Activity or the + button in Add More to add activities here.`;
        }
        if (effectiveClassFilter) {
            return `No list activities found for ${classLabel}. Select an area of work or use Add Activity to create one.`;
        }
        return 'No list activities found.';
    }, [effectiveClassFilter, filterSuperActivity, addClassList, addSuperActivityList]);

    const tableRows = useMemo(() => {
        if (tabelList.length > 0) return tabelList;
        if (!filterSuperActivity) return [];
        if (!effectiveClassFilter) return [];

        const selectedClass = addClassList.find((c) => String(c._id) === String(effectiveClassFilter));
        const selectedArea = addSuperActivityList.find(
            (area) => String(area._id) === String(filterSuperActivity)
        );
        if (!selectedArea) return [];

        return [{
            _id: `placeholder-${filterSuperActivity}`,
            isPlaceholder: true,
            classId: selectedClass
                ? { _id: effectiveClassFilter, className: selectedClass.className }
                : { _id: effectiveClassFilter, className: '' },
            superActivityId: selectedArea,
            activityName: '',
        }];
    }, [tabelList, effectiveClassFilter, filterSuperActivity, addClassList, addSuperActivityList]);

    const filteredTableRows = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return tableRows;
        return tableRows.filter((row) => {
            const cls = (row.classId?.className || '').toLowerCase();
            const area = (row.superActivityId?.superActivityName || '').toLowerCase();
            const name = (row.activityName || '').toLowerCase();
            return cls.includes(term) || area.includes(term) || name.includes(term);
        });
    }, [tableRows, searchTerm]);

    const hasActiveFilters = Boolean(effectiveClassFilter || filterSuperActivity);
    const showSchoolColumn = shouldShowSchoolColumn(embedded, scope);
    const displayHeaders = useMemo(
        () => (showSchoolColumn ? ['School', ...tableHeaders] : tableHeaders),
        [showSchoolColumn]
    );

    const renderSchoolCell = (row) => {
        if (!isSchoolAddedRow(row)) {
            return <Typography variant="caption" style={{ color: '#9aa6b6' }}>Default</Typography>;
        }
        const label = resolveRowSchoolLabel(row, addClassList);
        return label ? (
            <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={label} className={classes.classChip} />
        ) : (
            <Typography variant="caption" style={{ color: '#9aa6b6' }}>—</Typography>
        );
    };

    const renderActivityFilters = () => (
        <Grid container spacing={2}>
            {!useExternalScope && (
            <Grid item xs={12} sm={6}>
                <span className={classes.fieldLabel}>Class</span>
                <FormControl variant="outlined" size="small" fullWidth>
                    <Select
                        displayEmpty
                        value={filterClassId}
                        onChange={(e) => {
                            setfilterSuperActivity('');
                            setFilterClassId(e.target.value);
                        }}
                    >
                        <MenuItem value=""><em>All Classes</em></MenuItem>
                        {addClassList.map(({ _id, className }) => (
                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            )}
            <Grid item xs={12} sm={useExternalScope ? 12 : 6}>
                <span className={classes.fieldLabel}>Area Of Work</span>
                <FormControl variant="outlined" size="small" fullWidth>
                    <Select
                        displayEmpty
                        id="superActivityName"
                        name="superActivityId"
                        value={filterSuperActivity}
                        onChange={(e) => {
                            setfilterSuperActivity(e.target.value);
                            setpg(0);
                        }}
                    >
                        <MenuItem value=""><em>All Areas Of Work</em></MenuItem>
                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );

    const renderActivityTableRow = (tabel) => (
        <TableRow key={tabel._id} hover>
            {showSchoolColumn && <TableCell>{renderSchoolCell(tabel)}</TableCell>}
            <TableCell>
                {tabel.classId?.className ? (
                    <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={tabel.classId.className} className={classes.classChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {tabel.superActivityId?.superActivityName ? (
                    <Chip size="small" label={tabel.superActivityId.superActivityName} className={classes.areaChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {tabel.isPlaceholder ? (
                    <span className={classes.placeholderText}>No activities yet</span>
                ) : tabel.activityName ? (
                    <Chip size="small" label={tabel.activityName} className={classes.nameChip} />
                ) : '—'}
            </TableCell>
            <TableCell align="center">
                <Tooltip title="Add another activity in this area of work">
                    <IconButton className={classes.iconAction} size="small" onClick={() => addActivityFromRow(tabel)}>
                        <AddIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </TableCell>
            <TableCell>
                <Box display="flex" alignItems="center">
                    {!tabel.isPlaceholder && (
                        <Tooltip title="View">
                            <IconButton className={classes.viewIcon} size="small" onClick={() => openView(tabel)}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {!tabel.isPlaceholder && (
                        canEditDeleteActivityRow(tabel) ? (
                            <>
                                <Tooltip title="Edit">
                                    <IconButton className={classes.iconAction} size="small" onClick={() => editActivityTabel(tabel)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <IconButton className={classes.deleteIcon} size="small" onClick={() => deleteActivityTabel(tabel)}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </>
                        ) : (
                            <>
                                <EditIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be edited" />
                                <DeleteIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be deleted" />
                            </>
                        )
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );

    const renderActivityTable = () => (
        <>
            <TableContainer component={Paper} elevation={0} style={{ maxHeight: embedded ? 560 : 520 }}>
                <Table stickyHeader size="small" className="dashboard-table-row-hover">
                    <TableHead>
                        <TableRow>
                            {displayHeaders.map((key) => (
                                <TableCell key={key} className={classes.headCell}>{key}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredTableRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={displayHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                    <Typography variant="body2">
                                        {hasActiveFilters ? emptyActivityMessage : 'No list activities found.'}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            filteredTableRows.slice(pg * rpg, pg * rpg + rpg).map(renderActivityTableRow)
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                rowsPerPageOptions={[10, 25, 50, 100]}
                count={filteredTableRows.length}
                page={pg}
                onPageChange={handleChangePage}
                rowsPerPage={rpg}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );

    const pageContent = (
        <>
            {!embedded && (
            <PageTitle title="List Of Activities" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Activity
            </Button>} />
            )}
            {!embedded && (
            <Box style={{ marginBottom: 16, marginTop: 8, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                <Typography variant="body2" color="textSecondary">
                    By default, all area of work, activities, and exercise are added. If you want to add extra activities, add them here.
                </Typography>
            </Box>
            )}
            {embedded ? (
                <>
                    <Card elevation={0} className={classes.embeddedFiltersCard}>
                        <Box className={classes.filtersHeader}>
                            <Box display="flex" alignItems="center" gridGap={8}>
                                <FilterListIcon style={{ fontSize: 18, color: '#1769d6' }} />
                                <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.9rem' }}>
                                    List Of Activities
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classes.filtersBody}>
                            {renderActivityFilters()}
                            {hasActiveFilters && tabelList.length === 0 && tableRows.length === 0 && (
                                <Box className={classes.emptyFilterBox}>
                                    <Typography className={classes.emptyFilterText}>{emptyActivityMessage}</Typography>
                                </Box>
                            )}
                        </Box>
                    </Card>
                    <Card elevation={0} className={classes.embeddedTableCard}>
                        <Box className={classes.toolbar}>
                            <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                                {filteredTableRows.length} Activit{filteredTableRows.length === 1 ? 'y' : 'ies'}
                            </Typography>
                            <Box display="flex" alignItems="center" gridGap={10}>
                                <Button variant="contained" className={classes.primaryBtn} size="small" startIcon={<AddIcon />} onClick={() => handleOpen(true)}>
                                    Add Activity
                                </Button>
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search…"
                                    value={searchTerm}
                                    onChange={(e) => { setSearchTerm(e.target.value); setpg(0); }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Tooltip title="Refresh">
                                    <IconButton className={classes.iconBtnOutlined} size="small" onClick={fetchFilteredActivities}>
                                        <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        {renderActivityTable()}
                    </Card>
                </>
            ) : (
            <>
             <Card sx={{ maxWidth: 345 }}>
                <Box style={{margin:"15px"}}  >
            <Grid container spacing={2}>
                {!useExternalScope && (
                <Grid item xs={12} sm={6}>
                    <span className={classes.fieldLabel}>Class</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            value={filterClassId}
                            onChange={(e) => {
                                setfilterSuperActivity('');
                                setFilterClassId(e.target.value);
                            }}
                        >
                            <MenuItem value=""><em>All Classes</em></MenuItem>
                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                )}
                <Grid item xs={12} sm={useExternalScope ? 12 : 6}>
                    <span className={classes.fieldLabel}>Area Of Work</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            id="superActivityName"
                            name="superActivityId"
                            value={filterSuperActivity}
                            onChange={(e) => {
                                setfilterSuperActivity(e.target.value);
                                setpg(0);
                            }}
                        >
                            <MenuItem value=""><em>All Areas Of Work</em></MenuItem>
                            {addSuperActivityList.map(({ _id, superActivityName }) => (
                                <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {hasActiveFilters && tabelList.length === 0 && tableRows.length === 0 && (
                <Box className={classes.emptyFilterBox}>
                    <Typography className={classes.emptyFilterText}>
                        {emptyActivityMessage}
                    </Typography>
                </Box>
            )}

            </Box>
            </Card >
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                        
                        <Table stickyHeader size="small" className="dashboard-table-row-hover">
                            <TableHead >
                                <TableRow>
                                    {displayHeaders.map(key => (
                                        <TableCell key={key} className={classes.headCell}>{key}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredTableRows.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={displayHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                            <Typography variant="body2">
                                                {hasActiveFilters ? emptyActivityMessage : 'No list activities found.'}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    filteredTableRows.slice(pg * rpg, pg * rpg + rpg).map(renderActivityTableRow)
                                )}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            count={filteredTableRows.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            </>
            )}
            <Dialog open={open} onClose={handleClose} scroll="paper" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {tabel._id ? 'Edit Activity' : 'Add Activity'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} >
                                <span className={classes.fieldLabel}>Class</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <Select
                                        id="demo-simple-select"
                                        name="classId"
                                        displayEmpty
                                        value={formik.values.classId}
                                        onChange={e => {
                                            formik.handleChange(e);
                                            getSuperActivityList(e);
                                            const sid = resolveSchoolIdForClass(
                                                addClassList,
                                                e.target.value,
                                                useExternalScope ? scopeSchoolId : '',
                                                userDetails
                                            );
                                            if (sid) formik.setFieldValue('schooleId', sid);
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} >
                                <span className={classes.fieldLabel}>Area Of Work</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                >
                                    <Select
                                        id="superActivityName"
                                        name="superActivityId"
                                        displayEmpty
                                        onChange={formik.handleChange}
                                        value={formik.values.superActivityId}
                                    >
                                        <MenuItem value=""><em>Select Area Of Work</em></MenuItem>
                                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.superActivityId && formik.errors.superActivityId && (
                                        <FormHelperText>{formik.errors.superActivityId}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>List Of Activities</span>
                                <TextField
                                    fullWidth size="small" variant="outlined"
                                    autoFocus
                                    id="activityName"
                                    name="activityName"
                                    type="text"
                                    value={formik.values.activityName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.activityName && Boolean(formik.errors.activityName)}
                                    helperText={formik.touched.activityName && formik.errors.activityName}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>Notes</span>
                                <TextField
                                    fullWidth size="small" variant="outlined"
                                    id="notes"
                                    name="notes"
                                    multiline
                                    minRows={3}
                                    maxRows={8}
                                    value={formik.values.notes || ''}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn}>
                            {tabel._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog open={viewOpen} onClose={closeView} fullWidth maxWidth="sm">
                <DialogTitle>Activity Details</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2"><b>Class:</b> {viewRow?.classId?.className || ''}</Typography>
                    <Typography variant="body2"><b>Area Of Work:</b> {viewRow?.superActivityId?.superActivityName || ''}</Typography>
                    <Typography variant="body2"><b>Activity:</b> {viewRow?.activityName || ''}</Typography>
                    <Box mt={2}>
                        <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>Notes</Typography>
                        <Paper style={{ padding: 10, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
                            <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
                                {viewRow?.notes ? String(viewRow.notes) : "—"}
                            </Typography>
                        </Paper>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeView} style={{ backgroundColor: "rgb(15 59 98)", color: "white" }} variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => {
                    setDeleteConfirmOpen(false);
                    setPendingDelete(null);
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>localhost:3000 says</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        Are you sure you want to delete{" "}
                        <b>"{pendingDelete?.activityName ? String(pendingDelete.activityName) : "this activity"}"</b>?
                        <br />
                        <br />
                        This action cannot be undone. All associated data will be permanently removed.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={confirmDelete}
                        style={{ backgroundColor: "rgb(15 59 98)", color: "white" }}
                        variant="contained"
                    >
                        OK
                    </Button>
                    <Button
                        onClick={() => {
                            setDeleteConfirmOpen(false);
                            setPendingDelete(null);
                        }}
                        style={{ backgroundColor: "#f3e5e5", color: "#0f3b62" }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

    return pageContent;
}


